import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
const sizeClass = {
    sm: 'size-3.5 border-[1.5px]',
    md: 'size-4 border-2',
    lg: 'size-5 border-2',
};
/**
 * Yuklanish indikatori. Rangni `currentColor` dan oladi — shuning uchun
 * tugma ichida ham, matn yonida ham o'z-o'zidan to'g'ri ko'rinadi.
 */
export const Spinner = ({ size = 'md', label, className, ...rest }) => (_jsxs("span", { role: label ? 'status' : undefined, "aria-hidden": label ? undefined : true, className: cn('inline-flex items-center gap-2', className), ...rest, children: [_jsx("span", { className: cn('inline-block shrink-0 animate-spin rounded-[var(--radius-pill)] border-current', 'border-r-transparent opacity-70', sizeClass[size]) }), label ? _jsx("span", { className: "sr-only", children: label }) : null] }));
//# sourceMappingURL=Spinner.js.map